export const DIALOGUES = {
  prologue_intro: [
    { speaker: "Narration", text: "Every great love story begins somewhere." },
    { speaker: "Narration", text: "Ours began with a boy who wouldn't even turn around." }
  ],
  level1_notice: [
    { speaker: "Labonno", text: "I've seen that boy before... heading toward the apartments." }
  ],
  level1_rooftop: [
    { speaker: "Labonno", text: "Which school do you go to? And what class are you in?" },
    { speaker: "Talha", text: "Class four, MUBC school." },
    { speaker: "Labonno", text: "(He didn't even turn around?)" },
    { speaker: "Narration", text: "I didn't know his name. I didn't know his story. After that day, I never saw him again." },
    { speaker: "Narration", text: "...but the story wasn't over." }
  ],
  level2_pc_intro: [
    { speaker: "Talha", text: "Another quiet afternoon in 2016. Let's boot up the PC." }
  ],
  level3_combat_intro: [
    { speaker: "Royal Advisor", text: "Treason! The Queen is locked in the high spire! Knights of the Crimson Council, execute the trespasser!" },
    { speaker: "Knight Talha", text: "Step aside. No army on this earth will keep me from her." }
  ],
  level3_stage1_clear: [
    { speaker: "Knight Talha", text: "One down. The Royal Vanguard has fallen. I hear her voice beyond the inner courtyard!" }
  ],
  level3_stage2_clear: [
    { speaker: "Knight Talha", text: "The Shadow Knights cannot stop me. Only the High Champion stands between me and Labonno!" }
  ],
  level3_champion_clear: [
    { speaker: "Council Champion", text: "Impossible... your devotion... gives you boundless strength..." },
    { speaker: "Knight Talha", text: "My blade is sworn to one Queen, and one heart alone. Labonno, I'm coming!" }
  ],
  level3_rescue_queen: [
    { speaker: "Queen Labonno", text: "Talha! You fought through the entire fortress for me?!" },
    { speaker: "Knight Talha", text: "I told you ten years ago, and I tell you now: I will never let you go." },
    { speaker: "Queen Labonno", text: "The tower is collapsing! Take my hand—let's escape together!" }
  ],
  level3_castle_fall: [
    { speaker: "Queen Labonno", text: "Talha! The whole fortress is falling down around us!" },
    { speaker: "Knight Talha", text: "Hold onto me! We leap together!" }
  ],
  level3_hand_hold: [
    { speaker: "Knight Talha", text: "We are the only two people on this earth, and that's all that matters." }
  ],
  level3_garden_finale: [
    { speaker: "Labonno", text: "From a fleeting glance on a rooftop in 2011 to a random Facebook message in 2016..." },
    { speaker: "Talha", text: "Ten years passed in the blink of an eye." },
    { speaker: "Labonno", text: "Did you ever think we'd make it this far?" },
    { speaker: "Talha", text: "From the second I saw that friend request, I never doubted it for a moment." },
    { speaker: "Labonno", text: "You know, there's something you never did on that rooftop fifteen years ago." },
    { speaker: "Talha", text: "What's that?" },
    { speaker: "Labonno", text: "You never turned around." },
    { speaker: "Talha", text: "Well... I'm looking at you now. And I'm never looking away." },
    { speaker: "Labonno", text: "Only took you fifteen years. 🙂" }
  ]
};
